import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-top: ${props => props.theme.spacing.sp16};
`
